import type { EventSeriesData } from '@beat-venues/common-types';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { type ButtonOrLinkProps, ButtonOrLink, Heading } from '../../';
import type { CommonProps } from '../../types';

import type { JSX } from 'react';

export interface EventStoryProps
    extends CommonProps,
        Pick<ButtonOrLinkProps, 'href'> {
    image: EventSeriesData['image'];
    title: string;
}

export const EventStoryStyles = cva('relative group');

export const EventStory = ({
    className,
    image,
    href,
    title,
    testId = 'event-story',
    ...props
}: EventStoryProps): JSX.Element => {
    return (
        <div
            className={twMerge(EventStoryStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            {image ? (
                <div className="relative overflow-hidden rounded-md">
                    <img
                        alt={image.alt}
                        className="aspect-story object-cover transition group-hover:scale-105"
                        src={image.url}
                        height={611}
                        width={344}
                    />
                </div>
            ) : (
                <div className="overflow-hidden rounded-md">
                    <div className="aspect-story bg-tile group-hover:bg-tileHover object-cover"></div>
                </div>
            )}
            <ButtonOrLink
                className="absolute left-0 top-0 flex h-full w-full items-center justify-center p-4"
                href={href}
            >
                <Heading as="h3" className={image && 'opacity-0'}>
                    {title}
                </Heading>
            </ButtonOrLink>
        </div>
    );
};
